<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  @keyframes skate-1 {
    0% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
  #skate-1 {
    animation-name: skate-1;
  }
  @keyframes skate-2 {
    0% {
      opacity: 0;
    }
    50%,
    100% {
      opacity: 1;
    }
  }
  #skate-2 {
    animation-name: skate-2;
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 380.9 734.7" height="100%" width="100%">>
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="skate-2">
      <path
        fill="var(--hair)"
        d="M180 661c3 12 7 23 0 35-2 3 0 5 0 7 1 17 4 24-19 32h-15c-14-10-17-22-10-38 5-11 11-22 14-35a5 5 0 0 1 3-3l10-3c7-3 9-2 10 6 0 2-1 5 2 5 4 0 2-3 3-5l2-1ZM381 569c-3 1-2 4-3 6-5 11-19 13-27 3-8-9-10-20-11-32s-3-23-9-33c0-2 1-2 3-2 11-1 19-7 22-17h1c8 15 16 31 21 48 1 2 0 5 3 7Z"
      />
      <path
        fill="var(--shirt)"
        d="M244 272v2c9 6 11 16 16 25 4 8 13 15 13 26l-9 6c-16 10-32 21-51 25-29 6-59 6-89 4l-9-5c-2-4-2-8 1-12a6 6 0 0 0-1-7l-7-14c-15-23-21-50-30-76l-1-4c-1-2-2-3-5-3s-3 2-3 4c-2 6-6 11-12 14-11 1-20-2-27-12l-6-9c0-13 5-25 7-38 1-10 9-17 9-28l1-2c19-7 34-20 49-31l5-3 1 8c1 5 1 10 6 14 1 4 3 6 7 6h18c11 0 24-12 25-24 4-6 4-11-1-17a8 8 0 0 1-2-6c14 3 26 9 40 12a84 84 0 0 0 23 3c7 0 12 2 16 8 8 12 16 24 20 38 2 8 7 15 11 22 2 2 3 5 2 8-6 0-12 2-16 6s-8 4-12 0c-5-5-9-10-15-14-7-5-10-10-10-19v-20c0-5-2-7-6-9-7-5-14-2-22-3-4 0-9 2-10 5-2 5-3 10 2 14 3 2 3 5 4 8 2 12 5 23 14 32 3 3 7 2 8 5 7 13 17 23 22 37 4 11 12 20 24 24Z"
      />
      <path
        fill="var(--pants)"
        d="m115 355 9 5c30 2 60 2 90-4 18-4 34-15 50-25l9-6 4 7c4 16 10 31 16 47l11 32c3 6 7 10 12 14 3 4 4 7 0 11-4-6-10-6-16-4l-21 8c-10 4-20 9-16 23l-1 1c-5 1-8-2-10-7-11-18-22-36-38-51-1-1-3-4-5-3s-2 4-2 6c-1 14-7 27-13 40-3 7-5 14-5 22 1 8-3 12-11 14 1-8-3-10-10-10-12 0-24 2-36 4-4 1-9 0-12 4-3 0-5-1-5-5 2-20 1-41 0-61 0-12 4-25-4-37-4-8-1-17 4-25Z"
      />
      <path
        fill="var(--flesh)"
        d="m24 236 6 9c7 10 16 13 27 12-10 24-9 50-18 74-4 12-8 25-9 39a32 32 0 0 0 5 19 50 50 0 0 1 8 35c0 5-3 9-8 9-4 1-8 5-11 3-8-7-18-9-23-19-1-2-2-5 0-7l3-10c3-8 3-15 4-23 0-29-3-59 2-88 3-15 9-29 12-43a66 66 0 0 0 2-10ZM244 272c-12-4-19-13-24-24-5-14-15-24-22-37-1-3-5-2-8-5-8-9-12-20-14-32-1-3-1-5-4-8-5-3-4-9-2-14 1-3 6-5 10-5 8 1 15-1 22 3 4 2 6 5 6 9v21c0 8 3 14 10 18 6 4 10 9 15 14 4 4 8 4 12 0 5-4 10-6 16-6 0 3 1 5 3 8l11 20c6 14 2 36-9 45-3 3-5 4-9 0a35 35 0 0 0-13-7Z"
      />
      <path
        fill="var(--flesh)"
        d="m262 464 1-1c-4-14 6-19 16-23l21-8c6-2 12-2 16 4 0 7 4 14 6 21 1 2 3 3 6 3 18 2 24 6 26 25l3 9h-1c-3 10-11 16-22 17-2 0-3 0-3 2-9 0-17 2-26-1-17-4-28-17-35-33-2-5-2-11-8-15Z"
      />
      <path
        fill="var(--hair)"
        d="M152 56c0-6-1-12-6-16-3-2-3-4-3-8 0-6-4-11-10-10-15 4-30 4-45 4l-1 2c-6 4 0 11-3 16-6 5-7 10-5 18 1 2 4 7-2 10-4-19-2-38-2-57 0-3 1-6 5-8 15-4 30-9 47-6 6 1 12 3 15 10 1 3 4 2 6 3 7 2 10 6 10 13 0 10-2 19-3 29Z"
      />
      <path
        fill="var(--flesh)"
        d="M177 597c2-11 6-23-1-34-1-5-8-9-6-15 6-21 8-42 9-63 0-8-4-10-11-10-12 0-24 2-36 4-4 1-9 0-12 4 4 8 8 15 7 23 0 19 2 37-4 55-2 8-3 18 2 26l2 6c7 22 17 43 26 66l9-4c8-2 9-1 10 7 1 2 0 5 3 5 4 0 2-4 3-5l2-1c-11-21-7-42-3-64Z"
      />
      <path
        fill="var(--pants)"
        d="M152 56h3v8c-1 2 1 4-2 6-2-5-1-10-1-14Z"
      />
      <path
        fill="var(--flesh)"
        d="M162 70c1-5-1-8-7-6-1 2 1 4-2 6-2-5-1-10-1-14 0-6-1-12-6-16-3-2-3-4-3-8 0-6-4-11-10-10-15 4-30 4-45 4l-1 2c-6 4 0 11-3 16a3 3 0 0 0 2-1 3 3 0 0 1-2 1c-6 5-7 10-5 18 1 2 4 7-2 10-6 0-3 5-3 8 0 6 4 10 7 14 5 6 4 14 10 19 8 6 7 13 5 21v8c1 5 1 10 6 14 1 4 3 6 8 6h17c11 0 24-12 25-24 4-6 4-12-1-17a8 8 0 0 1-2-6c-7-9 0-17 4-23 6-7 7-14 9-22ZM87 28l1-2Z"
      />
    </g>
    <g id="skate-1">
      <path
        fill="var(--hair)"
        d="M147 536c0 10-2 20-6 29-2 5-5 10-11 10s-11-4-14-10c-1-3-1-8-4-10v-15c4-6 3-14 8-21 8 17 13 20 27 17Z"
      />
      <path
        fill="var(--shirt)"
        d="M140 233c-3-2-2-6 0-9 7-16 14-31 25-46 12-17 31-26 50-33l30-10 2 2c-8 4-8 11-8 19 1 14 7 27 16 38 11 14 28 12 38-3 8-13 15-26 15-42-1-2 0-4 1-5 15 6 27 18 39 28l2 2c23 15 26 38 27 63v21c0 4-1 7-3 11-5 3-11 7-17 4-8-3-16-2-24-1a22 22 0 0 1-2-3c-1-3 1-7-3-7-3-1-3 3-5 6-3 8-4 18-5 27-2 17-13 33-12 51 1 4-1 8-3 12-6 10-8 22-17 31 0-2-2-2-4-2l-25 7c-12 2-23 6-35 3-20-5-39-11-57-21-9-5-17-11-27-14-6-5-5-11-3-17l3-12c3 0 5 3 6 4l21 15c9 6 20 11 27 21 5 7 13 11 21 15 5 2 17 2 19-1l9-11c7-9 5-17-4-23-2-1-7-1-6-4s4-1 7-2c3 0 5-2 6-4 1-1 0-3-1-4-5-4-12-6-17-5-7 2-14 3-20 7h-5c-12-7-21-17-29-27-5-8-10-17-3-27a48 48 0 0 0 6-16c1-5 1-10 3-14 4-6 0-7-4-10-11-5-23-7-34-14Z"
      />
      <path
        fill="var(--pants)"
        d="M138 362c10 3 18 9 27 14 18 10 37 16 57 21 12 3 23-1 35-3l25-7c2 0 4 0 5 2l-3 19c-1 4-3 7-1 11-4 9-4 18-6 28l-2 9a242 242 0 0 1-11 36l-3-2-45-13c-3 0-3 2-5 3-7-9-5-19-6-29v-25c-6 7-8 14-9 21-5 14-13 26-18 40l-2 1c-7 1-13-1-19-1-11-4-23-5-33-10 0-3 1-6-1-8-1-29-1-58 9-85a122 122 0 0 0 6-22Z"
      />
      <path
        fill="var(--flesh)"
        d="M309 144c-1 1-2 3-1 5 0 16-7 29-15 42-10 15-27 17-38 3-9-11-15-24-16-38 0-8 0-15 8-19l-2-2c0-8-2-15-7-22-6-7-6-15-1-22 2 2 0 5 3 7 2-13-3-26 6-37l1-4c1-11 3-13 14-12 10 2 19 2 29 0a32 32 0 0 1 8-2c8 0 13 4 12 13 0 3 1 6 3 8 4 4 6 10 5 16v16c3-2 2-5 3-6 7-2 8 2 7 8-3 8-5 16-11 23-5 6-11 14-8 23Z"
      />
      <path
        fill="var(--flesh)"
        d="M140 233c11 7 23 9 34 14 4 3 8 4 4 10-2 4-2 9-3 14a48 48 0 0 1-6 16c-7 10-2 20 3 27 8 10 17 20 29 27h5c6-4 13-5 20-7 5-1 12 1 17 5 1 1 2 3 1 4-1 2-3 4-6 4-3 1-7-1-7 2s4 3 6 4c9 6 11 14 4 23l-9 11c-2 3-14 3-19 1-8-4-16-8-21-15-7-10-18-15-27-21l-21-15c-1-1-3-4-6-4l-9-11c-7-8-10-16-5-27 8-20 10-41 16-62ZM211 480c2-1 2-3 5-3l45 13 3 2c-9 21-13 44-12 67 1 10-2 19-5 28-8 22-17 43-24 65l-4 16h-3c-7-7-10-8-18-1 0 1-1 2-2 0l1-3c9-31 1-64 10-96v-4c11-26 4-53 6-80l-2-4ZM283 419c-2-4 0-7 1-11l21-9c5-2 8-5 10-10 9-25 15-51 23-76a16 16 0 0 0 0-7 148 148 0 0 1-3-29c0-2 0-4-2-5 8-1 16-2 24 1 6 3 12-1 17-4l-2 21c-1 5-2 10-1 14 5 22-5 40-15 58a293 293 0 0 1-19 32c-7 9-9 20-12 31-3 13-12 19-22 25-9 4-19 3-28 6l2-9c6-1 9-6 13-10 5-5 7-9 4-16s-8-1-11-2Z"
      />
      <path
        fill="var(--hair)"
        d="M321 90c-1 2 0 4-3 6V80c1-6-1-12-5-16-2-2-3-5-3-8 1-9-4-13-12-13a32 32 0 0 0-8 2c-10 2-19 2-29 0-11-1-13 1-14 12l-1 4c-9 11-4 24-6 37-3-2-1-5-3-7-3-19-1-39 0-58 0-4 3-7 7-8 17-4 35-10 54-3 5 2 10 4 12 9 1 4 4 4 6 5 7 2 10 6 10 14 0 13-5 26-5 40ZM197 664l-1 3c1 2 2 1 2 0 8-7 11-6 18 1h3a129 129 0 0 0 14 37c4 5 2 10-2 15a35 35 0 0 1-23 12c-7 0-12-2-13-9-3-17-6-35-3-53 0-2 0-6 5-6Z"
      />
      <path
        fill="var(--flesh)"
        d="M176 488c-7 1-13-1-19-1-11-4-23-5-33-10h-1c1 14-5 28-3 42 8 17 13 20 27 17 11-6 20-14 22-27 3-2 2-5 2-8a1 1 0 0 0 1-1c3-3 2-8 4-12Z"
      />
      <path fill="var(--hair)" d="M124 477h-1v-8c2 2 1 5 1 8Z" />
    </g>
  </g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>